import {defineMessages} from 'react-intl';

export default defineMessages({
	sortBy: {
		id: 'plp.sorting.sortBy',
		defaultMessage: 'Sort By'
	},
	selected: {
		id: 'plp.selected.selected',
		defaultMessage: '{totalSelected} Selected'
	},
	material: {
		id: 'plp.refinements.material',
		defaultMessage: 'Material'
	},
	fit: {
		id: 'plp.refinements.fit',
		defaultMessage: 'Fit'
	},
	size: {
		id: 'plp.refinements.size',
		defaultMessage: 'Size'
	},
	colorData: {
		id: 'plp.refinements.colorData',
		defaultMessage: 'Color'
	},
	category: {
		id: 'plp.refinements.category',
		defaultMessage: 'Category'
	},
	priceLowToHigh: {
		id: 'plp.refinements.priceLowToHigh',
		defaultMessage: 'Price Low To High'
	},
	priceHighToLow: {
		id: 'plp.refinements.priceHighToLow',
		defaultMessage: 'Price High To Low'
	},
});
